// extracted by mini-css-extract-plugin
export default {"w-full":"Payouts_w-full__h8EMn","card":"Payouts_card__Fxa7a"};